import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "search-bar-container" }
const _hoisted_2 = { class: "search-fields" }
const _hoisted_3 = { class: "search-field" }
const _hoisted_4 = { class: "search-field" }
const _hoisted_5 = { class: "search-field" }
const _hoisted_6 = { class: "search-field" }
const _hoisted_7 = { class: "search-field" }
const _hoisted_8 = { class: "search-field" }
const _hoisted_9 = { class: "search-field" }
const _hoisted_10 = { class: "search-buttons" }
const _hoisted_11 = { class: "stats-and-actions" }
const _hoisted_12 = { class: "table-stats" }
const _hoisted_13 = { class: "stats-item" }
const _hoisted_14 = { class: "action-buttons" }
const _hoisted_15 = { class: "id-card-cell" }
const _hoisted_16 = { class: "phone-cell" }
const _hoisted_17 = { class: "text-ellipsis" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "text-ellipsis" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "text-ellipsis" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "flex flex-ai-c" }
const _hoisted_24 = { class: "decorate-box" }
const _hoisted_25 = { class: "tags-container" }
const _hoisted_26 = {
  key: 0,
  class: "tag-more"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "pagination-container" }
const _hoisted_30 = {
  key: 0,
  class: "tag-dialog-content"
}
const _hoisted_31 = { class: "remove-tag-grid" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "remove-tag-label" }
const _hoisted_34 = {
  key: 1,
  class: "tag-dialog-content"
}
const _hoisted_35 = { class: "tag-section" }
const _hoisted_36 = { class: "tag-list" }
const _hoisted_37 = {
  key: 0,
  class: "tag-desc"
}
const _hoisted_38 = { class: "tag-section" }
const _hoisted_39 = { class: "tag-section-title" }
const _hoisted_40 = { class: "tag-list custom-tag-list" }
const _hoisted_41 = ["onMouseenter"]
const _hoisted_42 = { class: "dialog-footer" }
const _hoisted_43 = { class: "remove-error-list" }
const _hoisted_44 = { class: "remove-error-row" }
const _hoisted_45 = { class: "remove-error-reason" }
const _hoisted_46 = { class: "remove-error-row" }
const _hoisted_47 = { class: "remove-error-names" }
const _hoisted_48 = { class: "dialog-footer" }
const _hoisted_49 = { class: "dialog-footer" }
const _hoisted_50 = { class: "dialog-footer" }
const _hoisted_51 = { class: "resign-dialog-footer" }
const _hoisted_52 = { class: "no-remind-checkbox" }
const _hoisted_53 = { class: "dialog-buttons" }
const _hoisted_54 = { class: "mark-expert-dialog-content" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = { class: "upload-container" }
const _hoisted_58 = ["src", "alt"]
const _hoisted_59 = {
  key: 0,
  class: "upload-box"
}
const _hoisted_60 = { class: "dialog-footer" }
const _hoisted_61 = { class: "upload-dialog-content" }
const _hoisted_62 = {
  key: 1,
  class: "upload-success"
}
const _hoisted_63 = { class: "file-info" }
const _hoisted_64 = { class: "dialog-footer" }
const _hoisted_65 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_FolderAdd = _resolveComponent("FolderAdd")!
  const _component_Hide = _resolveComponent("Hide")!
  const _component_View = _resolveComponent("View")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_tableComponent = _resolveComponent("tableComponent")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_DrawerEmployeeDetail = _resolveComponent("DrawerEmployeeDetail")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_Document = _resolveComponent("Document")!
  const _component_circle_check_filled = _resolveComponent("circle-check-filled")!
  const _component_download = _resolveComponent("download")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.searchText.name), 1),
            _createVNode(_component_el_input, {
              modelValue: _ctx.searchList.searchText.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchList.searchText.value) = $event)),
              placeholder: _ctx.searchList.searchText.placeholder,
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.phone.name), 1),
            _createVNode(_component_el_input, {
              modelValue: _ctx.searchList.phone.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchList.phone.value) = $event)),
              placeholder: _ctx.searchList.phone.placeholder,
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.idCardNo.name), 1),
            _createVNode(_component_el_input, {
              modelValue: _ctx.searchList.idCardNo.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchList.idCardNo.value) = $event)),
              placeholder: _ctx.searchList.idCardNo.placeholder,
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.isLogout.name), 1),
            _createVNode(_component_el_select, {
              modelValue: _ctx.searchList.isLogout.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchList.isLogout.value) = $event)),
              placeholder: _ctx.searchList.isLogout.placeholder,
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchList.isLogout.options, (opt) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: opt.value,
                    label: opt.label,
                    value: opt.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.statusFilter.name), 1),
            _createVNode(_component_el_select, {
              modelValue: _ctx.searchList.statusFilter.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchList.statusFilter.value) = $event)),
              placeholder: _ctx.searchList.statusFilter.placeholder,
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchList.statusFilter.options, (opt) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: opt.value,
                    label: opt.label,
                    value: opt.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.labelIds.name), 1),
            _createVNode(_component_el_select, {
              modelValue: _ctx.searchList.labelIds.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchList.labelIds.value) = $event)),
              placeholder: _ctx.searchList.labelIds.placeholder,
              clearable: "",
              multiple: "",
              filterable: "",
              "collapse-tags": "",
              "collapse-tags-tooltip": true,
              "max-collapse-tags": 2,
              onChange: _ctx.handleLabelChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchList.labelIds.options, (opt) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: opt.value,
                    label: opt.label,
                    value: opt.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", null, _toDisplayString(_ctx.searchList.entryTime.name), 1),
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.searchList.entryTime.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchList.entryTime.value) = $event)),
              type: "daterange",
              "start-placeholder": _ctx.searchList.entryTime.startPlaceholder,
              "end-placeholder": _ctx.searchList.entryTime.endPlaceholder
            }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleSearch
            }, {
              default: _withCtx(() => _cache[37] || (_cache[37] = [
                _createTextVNode("搜索")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.handleReset }, {
              default: _withCtx(() => _cache[38] || (_cache[38] = [
                _createTextVNode("重置")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, "共" + _toDisplayString(_ctx.statistics.totalCount || 0) + "人：男" + _toDisplayString(_ctx.statistics.menCount || 0) + "人 / 女" + _toDisplayString(_ctx.statistics.womenCount || 0) + "人", 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.isAdminOrAbove)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "batch-undo-btn",
                plain: "",
                onClick: _ctx.handleBatchRemoveTag
              }, {
                default: _withCtx(() => _cache[39] || (_cache[39] = [
                  _createTextVNode(" 批量移除 ")
                ])),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isAdminOrAbove)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                plain: "",
                onClick: _ctx.handleBatchTag
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Plus)
                    ]),
                    _: 1
                  }),
                  _cache[40] || (_cache[40] = _createTextVNode(" 批量标签 "))
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: _ctx.handleBatchImport
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FolderAdd)
                ]),
                _: 1
              }),
              _cache[41] || (_cache[41] = _createTextVNode(" 导入名单 "))
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_tableComponent, {
        class: "mg-t-10",
        "table-data": _ctx.tableData,
        "table-head": _ctx.filteredTableHead,
        "row-key": "id",
        onSelectionChange: _ctx.handleSelectionChange,
        ref: "table"
      }, {
        sex: _withCtx((scope) => [
          _createElementVNode("view", null, _toDisplayString(scope.row.sex === '0' ? '男' : '女'), 1)
        ]),
        idCardNo: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(_ctx.getDisplayValue(scope.row.id, 'idCardNo', scope.row.idCardNo)), 1),
            _createVNode(_component_el_icon, {
              class: "toggle-icon",
              onClick: ($event: any) => (_ctx.toggleVisibility(scope.row.id, 'idCardNo'))
            }, {
              default: _withCtx(() => [
                (_ctx.isIdCardVisible(scope.row.id))
                  ? (_openBlock(), _createBlock(_component_Hide, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_View, { key: 1 }))
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        phone: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", null, _toDisplayString(_ctx.getDisplayValue(scope.row.id, 'phone', scope.row.phone)), 1),
            _createVNode(_component_el_icon, {
              class: "toggle-icon",
              onClick: ($event: any) => (_ctx.toggleVisibility(scope.row.id, 'phone'))
            }, {
              default: _withCtx(() => [
                (_ctx.isPhoneVisible(scope.row.id))
                  ? (_openBlock(), _createBlock(_component_Hide, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_View, { key: 1 }))
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        workerName: _withCtx((scope) => [
          (scope.row.workerName && scope.row.workerName.length > 7)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: scope.row.workerName,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(scope.row.workerName), 1)
                ]),
                _: 2
              }, 1032, ["content"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(scope.row.workerName), 1))
        ]),
        projectName: _withCtx((scope) => [
          (scope.row.projectName && scope.row.projectName.length > 12)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: scope.row.projectName,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(scope.row.projectName), 1)
                ]),
                _: 2
              }, 1032, ["content"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(scope.row.projectName), 1))
        ]),
        serveCompanyName: _withCtx((scope) => [
          (scope.row.serveCompanyName && scope.row.serveCompanyName.length > 12)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: scope.row.serveCompanyName,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(scope.row.serveCompanyName), 1)
                ]),
                _: 2
              }, 1032, ["content"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(scope.row.serveCompanyName), 1))
        ]),
        statusFilter: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass(['status-badge', _ctx.searchList.statusFilter.value === 'insured' ? 'status-green' : 'status-blue'])
          }, _toDisplayString(_ctx.searchList.statusFilter.value === 'insured' ? '保障中' : '待生效'), 3)
        ]),
        isActivity: _withCtx((scope) => [
          _createElementVNode("span", {
            class: _normalizeClass(['status-badge', scope.row.isActivity === 0 ? 'status-yellow' : 'status-gray'])
          }, _toDisplayString(scope.row.isActivity === 0 ? '待激活' : '已激活'), 3)
        ]),
        "isActivity-header": _withCtx(() => [
          _createElementVNode("div", _hoisted_23, [
            _cache[42] || (_cache[42] = _createElementVNode("span", { class: "mg-r-5" }, "激活状态", -1)),
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: "待激活：入职超过30天且近30天未发薪、未投保、未签合同的职工",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Warning, { color: "#9497B1" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        isLogout: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", {
              class: "decorate",
              style: _normalizeStyle({
                        background: scope.row.isLogout === 0 ? '#00D679' : '#FF7642'
                    })
            }, null, 4),
            _createElementVNode("p", null, _toDisplayString(scope.row.isLogout === 0 ? '正常' : '已注销'), 1)
          ])
        ]),
        labels: _withCtx((scope) => [
          (scope.row.labels && scope.row.labels.length > 0)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                "popper-class": "labels",
                content: scope.row.labels.map((tag) => tag.labelName).join('、'),
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.labels.slice(0, 2), (tag, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "tag-item"
                      }, _toDisplayString(_ctx.truncateText(tag.labelName, 5)), 1))
                    }), 128)),
                    (scope.row.labels.length > 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, " +" + _toDisplayString(scope.row.labels.length - 2), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["content"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_27, "--"))
        ]),
        operate: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_28, [
            (_ctx.isAdminOrAbove)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "text",
                  size: "middle",
                  onClick: ($event: any) => (_ctx.handleAddTag(scope.row))
                }, {
                  default: _withCtx(() => _cache[43] || (_cache[43] = [
                    _createTextVNode("+标签")
                  ])),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "text",
              size: "middle",
              onClick: ($event: any) => (_ctx.handleDetail(scope.row))
            }, {
              default: _withCtx(() => _cache[44] || (_cache[44] = [
                _createTextVNode("详情")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["table-data", "table-head", "onSelectionChange"]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.pageInfo.pageNum,
          "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageInfo.pageNum) = $event)),
          "page-size": _ctx.pageInfo.pageSize,
          "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pageInfo.pageSize) = $event)),
          "page-sizes": [10, 20, 50],
          total: _ctx.pageInfo.totalCount,
          layout: "total, sizes, prev, pager, next, jumper",
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ]),
      (_ctx.imageViewerVisible)
        ? (_openBlock(), _createBlock(_component_el_image_viewer, {
            key: 0,
            "url-list": _ctx.previewImages,
            onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.imageViewerVisible = false))
          }, null, 8, ["url-list"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.tagDialogVisible,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tagDialogVisible) = $event)),
        title: _ctx.isRemoveMode ? '批量移除' : '加标签',
        width: "700px",
        "show-close": false,
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_el_button, { onClick: _ctx.handleCancelTags }, {
              default: _withCtx(() => _cache[47] || (_cache[47] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleConfirmBatchTags
            }, {
              default: _withCtx(() => _cache[48] || (_cache[48] = [
                _createTextVNode("确定")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.isRemoveMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _cache[45] || (_cache[45] = _createElementVNode("div", { class: "remove-title" }, [
                  _createElementVNode("div", { class: "remove-title-left" }, "已选员工标签"),
                  _createElementVNode("div", { class: "remove-title-desc" }, "从已选员工标签中选择标签后移除")
                ], -1)),
                _createElementVNode("div", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.removeModeTags, (tag) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tag.id,
                      class: _normalizeClass(["remove-tag-item", { checked: tag.checked }]),
                      onClick: ($event: any) => (tag.checked = !tag.checked)
                    }, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: tag.checked,
                        "onUpdate:modelValue": ($event: any) => ((tag.checked) = $event),
                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(tag.labelName), 1)
                    ], 10, _hoisted_32))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "tag-section-title" }, "系统标签", -1)),
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemTags, (tag) => {
                      return _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: tag.id,
                        class: _normalizeClass(["system-tag-item", { checked: tag.checked }])
                      }, [
                        _createVNode(_component_el_checkbox, {
                          modelValue: tag.checked,
                          "onUpdate:modelValue": ($event: any) => ((tag.checked) = $event),
                          class: _normalizeClass(['system-tag-checkbox', { checked: tag.checked }]),
                          onChange: ($event: any) => (_ctx.handleSystemTagChange(tag))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag.labelName), 1)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "class", "onChange"]),
                        (tag.labelDescription)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(tag.labelDescription), 1))
                          : _createCommentVNode("", true)
                      ], 2)), [
                        [_vShow, !_ctx.isRemoveMode || _ctx.removeModeTagIds.has(String(tag.id))]
                      ])
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("span", null, "自定义标签 " + _toDisplayString(_ctx.selectedCustomTags.length) + "/30", 1),
                    _withDirectives(_createElementVNode("div", {
                      class: "tag-add",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleAddCustomTag && _ctx.handleAddCustomTag(...args)))
                    }, "+标签", 512), [
                      [_vShow, !_ctx.isRemoveMode]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customTags, (tag) => {
                      return _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: tag.id,
                        class: _normalizeClass(["custom-tag-item", { checked: tag.checked }]),
                        onMouseenter: ($event: any) => (_ctx.hoveredTagId = tag.id),
                        onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (_ctx.hoveredTagId = null))
                      }, [
                        _createVNode(_component_el_checkbox, {
                          modelValue: tag.checked,
                          "onUpdate:modelValue": ($event: any) => ((tag.checked) = $event),
                          class: _normalizeClass(['custom-tag-checkbox', { checked: tag.checked, deleting: tag.deleting }])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag.labelName), 1)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "class"]),
                        _withDirectives(_createVNode(_component_el_icon, {
                          class: "delete-icon",
                          onClick: ($event: any) => (_ctx.handleAskDeleteTag(tag))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CircleCloseFilled, { color: "#C0C0CE" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]), [
                          [_vShow, _ctx.hoveredTagId === tag.id && !tag.deleting && !_ctx.isRemoveMode]
                        ])
                      ], 42, _hoisted_41)), [
                        [_vShow, !_ctx.isRemoveMode || _ctx.removeModeTagIds.has(String(tag.id))]
                      ])
                    }), 128))
                  ])
                ])
              ]))
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.removeErrorDialogVisible,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.removeErrorDialogVisible) = $event)),
        title: "部分操作失败",
        width: "540px",
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_el_button, {
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.removeErrorDialogVisible = false))
            }, {
              default: _withCtx(() => _cache[51] || (_cache[51] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.removeErrorDialogVisible = false))
            }, {
              default: _withCtx(() => _cache[52] || (_cache[52] = [
                _createTextVNode("确定")
              ])),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_43, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.removeErrorGroups, (group, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "remove-error-group"
              }, [
                _createElementVNode("div", _hoisted_44, [
                  _cache[49] || (_cache[49] = _createElementVNode("span", { class: "remove-error-label" }, "错误原因：", -1)),
                  _createElementVNode("span", _hoisted_45, _toDisplayString(group.reason), 1)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[50] || (_cache[50] = _createElementVNode("span", { class: "remove-error-label" }, "人员名单：", -1)),
                  _createElementVNode("span", _hoisted_47, _toDisplayString(group.names.join('、')), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.deleteTagDialogVisible,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.deleteTagDialogVisible) = $event)),
        title: "删除标签",
        width: "480px",
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_el_button, {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.deleteTagDialogVisible = false))
            }, {
              default: _withCtx(() => _cache[53] || (_cache[53] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleConfirmDeleteTag
            }, {
              default: _withCtx(() => _cache[54] || (_cache[54] = [
                _createTextVNode("确定")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _cache[55] || (_cache[55] = _createElementVNode("div", { class: "delete-tag-tip" }, "删除后将会移除所有关联员工的该标签信息，确定删除吗", -1))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.addTagDialogVisible,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.addTagDialogVisible) = $event)),
        title: "新增标签",
        width: "400px"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_el_button, {
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.addTagDialogVisible = false))
            }, {
              default: _withCtx(() => _cache[56] || (_cache[56] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleConfirmAddTag
            }, {
              default: _withCtx(() => _cache[57] || (_cache[57] = [
                _createTextVNode("确定")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            model: _ctx.newTagForm,
            "label-width": "80px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "标签名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.newTagForm.name,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newTagForm.name) = $event)),
                    placeholder: "请输入标签名称，最长8字",
                    maxlength: "8",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.resignWarningVisible,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.resignWarningVisible) = $event)),
        title: "标记离职提示",
        width: "480px",
        "show-close": true,
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.noRemindResignWarning,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.noRemindResignWarning) = $event))
              }, {
                default: _withCtx(() => _cache[58] || (_cache[58] = [
                  _createTextVNode("不再提醒")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_el_button, { onClick: _ctx.handleCancelResignWarning }, {
                default: _withCtx(() => _cache[59] || (_cache[59] = [
                  _createTextVNode("取消")
                ])),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleConfirmResignWarning
              }, {
                default: _withCtx(() => _cache[60] || (_cache[60] = [
                  _createTextVNode("确定")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _cache[61] || (_cache[61] = _createElementVNode("div", { class: "resign-warning-content" }, [
            _createElementVNode("p", { class: "warning-text" }, " 员工标记离职后，将从当前列表移入离职列表，且无法被其他项目搜索或添加。若该员工重新加入项目，离职标记将自动解除；也可在离职列表中手动为其解除离职状态 ")
          ], -1))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.markExpertDialogVisible,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.markExpertDialogVisible) = $event)),
        title: "加入黑名单",
        width: "600px",
        "show-close": true,
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_60, [
            _createVNode(_component_el_button, {
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.markExpertDialogVisible = false))
            }, {
              default: _withCtx(() => _cache[65] || (_cache[65] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleConfirmMarkExpert
            }, {
              default: _withCtx(() => _cache[66] || (_cache[66] = [
                _createTextVNode("提交")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _cache[62] || (_cache[62] = _createElementVNode("label", null, "备注", -1)),
              _createVNode(_component_el_input, {
                modelValue: _ctx.markExpertForm.remark,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.markExpertForm.remark) = $event)),
                type: "textarea",
                rows: 2,
                placeholder: "请输入拉黑原因，最多输入15字。",
                maxlength: "15",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _cache[63] || (_cache[63] = _createElementVNode("label", null, "上传照片", -1)),
              _createElementVNode("div", _hoisted_57, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markExpertForm.images, (file, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "image-item"
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.getImageUrl(file),
                      alt: `上传图片${index + 1}`
                    }, null, 8, _hoisted_58),
                    _createVNode(_component_el_icon, {
                      class: "remove-icon",
                      onClick: ($event: any) => (_ctx.removeImage(index))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Close)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 128)),
                _createVNode(_component_el_upload, {
                  action: "",
                  "auto-upload": false,
                  limit: 4,
                  accept: "image/*",
                  "show-file-list": false,
                  onChange: _ctx.handleImageChange,
                  onExceed: _ctx.handleExceedImage,
                  "before-upload": () => false
                }, {
                  default: _withCtx(() => [
                    (_ctx.markExpertForm.images.length < 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["onChange", "onExceed"])
              ]),
              _cache[64] || (_cache[64] = _createElementVNode("div", { class: "upload-tip" }, "上传照片截图，最多传4张（选填）", -1))
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_DrawerEmployeeDetail, {
        show: _ctx.detailDrawerVisible,
        "onUpdate:show": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.detailDrawerVisible) = $event)),
        "employee-data": _ctx.detailEmployeeData
      }, null, 8, ["show", "employee-data"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.uploadVisible,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.uploadVisible) = $event)),
        title: "导入名单",
        width: "510px",
        "show-close": true,
        center: "",
        onClose: _ctx.handleCancelUpload
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_el_button, { onClick: _ctx.handleCancelUpload }, {
              default: _withCtx(() => _cache[72] || (_cache[72] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleConfirmUpload,
              disabled: !_ctx.uploadedFile
            }, {
              default: _withCtx(() => _cache[73] || (_cache[73] = [
                _createTextVNode("确定")
              ])),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", {
              class: _normalizeClass(["custom-upload-area", { 'drag-over': _ctx.dragover }]),
              onDragover: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.dragover = true), ["prevent"])),
              onDragleave: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.dragover = false), ["prevent"])),
              onDrop: _cache[32] || (_cache[32] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
            }, [
              _createElementVNode("input", {
                ref: "fileInput",
                type: "file",
                accept: ".xls,.xlsx",
                style: {"display":"none"},
                onChange: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args)))
              }, null, 544),
              (!_ctx.uploadedFile)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "upload-empty",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$refs.fileInput.click()))
                  }, [
                    _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_upload_filled, { color: "#C0C4CC" })
                      ]),
                      _: 1
                    }),
                    _cache[67] || (_cache[67] = _createElementVNode("div", { class: "el-upload__text" }, [
                      _createElementVNode("div", null, "点击或将文件拖拽到这里"),
                      _createElementVNode("div", null, "（支持格式：xls、xlsx）")
                    ], -1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.handleReupload
                    }, {
                      default: _withCtx(() => _cache[68] || (_cache[68] = [
                        _createTextVNode("重新上传")
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _cache[69] || (_cache[69] = _createElementVNode("div", { class: "upload-tip" }, "（支持格式：xls、xlsx）", -1)),
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_el_icon, { size: "8" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Document, {
                            color: "#909399",
                            size: "8"
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.uploadedFile.name), 1),
                      _createVNode(_component_el_icon, { class: "success-icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_circle_check_filled, { color: "#67C23A" })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
            ], 34),
            _createElementVNode("div", {
              class: "template-download",
              onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadTemplate && _ctx.handleDownloadTemplate(...args)))
            }, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_download, { color: "#1989FA" })
                ]),
                _: 1
              }),
              _cache[70] || (_cache[70] = _createElementVNode("div", { class: "download-link" }, "下载导入模版", -1)),
              _cache[71] || (_cache[71] = _createElementVNode("div", { class: "download-desc" }, "请根据模版格式填写信息", -1))
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.importErrorDialogVisible,
        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.importErrorDialogVisible) = $event)),
        title: "名单错误",
        width: "700px",
        "close-on-click-modal": false,
        center: "",
        onClose: _ctx.handleCancelUpload
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.importErrorDialogVisible = false))
            }, {
              default: _withCtx(() => _cache[74] || (_cache[74] = [
                _createTextVNode("确定")
              ])),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: _ctx.importErrorList,
            style: {"width":"100%","margin-top":"10px","color":"#565868"},
            "header-cell-style": "background: #FAFAFC;color: #202536;"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "workerName",
                label: "姓名",
                align: "left",
                width: "170"
              }),
              _createVNode(_component_el_table_column, {
                prop: "idCardNo",
                label: "身份证号",
                align: "left",
                width: "190"
              }),
              _createVNode(_component_el_table_column, {
                prop: "errorMsg",
                label: "错误提示",
                align: "left"
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"])
    ]),
    _: 1
  }))
}